(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selectors = '.minarco-section__heading, .minarco-collection, .minarco-story__text, .minarco-story__image-wrap, .minarco-values__layout, .minarco-guide__grid article, .minarco-faq__layout > div, .collection .grid__item, .minarco-about .rte h2, .minarco-about .rte p, #contact .contact';
  let observer;
  const reveal = (element) => element.classList.add('is-visible');
  const observe = (root) => {
    if (!observer || motion.matches) return;
    root.querySelectorAll(selectors).forEach((element) => {
      if (element.classList.contains('minarco-reveal')) return;
      element.classList.add('minarco-reveal');
      if (element.getBoundingClientRect().top < window.innerHeight) reveal(element);
      else observer.observe(element);
    });
  };
  if (!motion.matches && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { reveal(entry.target); observer.unobserve(entry.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });
    document.documentElement.classList.add('minarco-motion-ready');
    observe(document);
  }
  motion.addEventListener('change', () => {
    if (!motion.matches) return;
    document.documentElement.classList.remove('minarco-motion-ready');
    document.querySelectorAll('.minarco-reveal').forEach(reveal);
    observer?.disconnect();
  });
  const enhanceImages = (root) => root.querySelectorAll('img[data-minarco-fallback]').forEach((image) => {
    if (image.dataset.minarcoBound) return;
    image.dataset.minarcoBound = 'true';
    const recover = () => {
      if (image.dataset.minarcoRecovered) return;
      image.dataset.minarcoRecovered = 'true';
      const fallback = image.dataset.minarcoFallback;
      if (!fallback || new URL(fallback, document.baseURI).href === image.src) return;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = fallback;
    };
    image.addEventListener('error', recover);
    if (image.complete && image.naturalWidth === 0) recover();
  });
  enhanceImages(document);
  document.addEventListener('shopify:section:load', (event) => { observe(event.target); enhanceImages(event.target); });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.minarco-reveal').forEach((element) => observer?.unobserve(element));
  });
  document.addEventListener('shopify:section:select', (event) => {
    event.target.querySelectorAll('.minarco-reveal').forEach(reveal);
  });
  const support = document.getElementById('MinarcoSupport');
  if (!support) return;
  if (support.querySelector('[data-support-feedback]')) support.open = true;
  support.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && support.open) {
      support.open = false;
      support.querySelector('summary').focus();
    }
  });
})();
